import { css } from "@emotion/react";
import styled from "@emotion/styled";

import {
  alignmentCssVariableValues,
  setFullViewportWidthBackgroundStyles,
  setFullViewportWidthStyles,
  setResponsiveVariantStyles,
  theme,
  ZIndexLayer,
} from "shared/lib/styles";
import type { ResponsiveVariants } from "shared/lib/styles";

import { applyStylesOnSlotCollapsed } from "scmp-app/components/advertisement/styles";
import { Header } from "scmp-app/components/header";
import { HomeHeader } from "scmp-app/components/home/header";

import { DynamicPlusHeader } from "./dynamics";
import type { AppBarVariant } from "./types";

export const FullWidthBackground = styled.div`
  ${setFullViewportWidthBackgroundStyles("#ffffff")}
  transition: background-color 0.3s ease-in;
`;

type AppBarContainerProps = {
  $appBarVariant?: AppBarVariant;
};

export const Container = styled.header<AppBarContainerProps>`
  inset-block-start: 0;
  z-index: ${ZIndexLayer.AppBar};

  ${props => {
    if (props.$appBarVariant === "scmp/plus") {
      return css`
        ${FullWidthBackground} {
          background-color: transparent;
        }
      `;
    }
  }}
`;

type AdSlotProps = {
  $hasBorderBottom?: boolean;
  $responsiveVariants: ResponsiveVariants<{
    $height: number;
    $isVisible?: boolean;
    $padding: number;
  }>;
};

export const AdSlotContainer = styled.div<AdSlotProps>`
  ${setFullViewportWidthStyles()}
  box-sizing: content-box;

  background-color: #f6f6f6;
  border-block-end: ${({ $hasBorderBottom }) => ($hasBorderBottom ? "1px solid #dfdfdf" : "none")};

  overflow: hidden;

  ${applyStylesOnSlotCollapsed()}

  ${props =>
    setResponsiveVariantStyles(
      props.$responsiveVariants,
      variant => css`
        display: ${variant.$isVisible ? "block" : "none"};

        block-size: ${`${variant.$height}px`};
        padding-block: ${`${variant.$padding}px`};
      `,
    )}
`;

export const HeaderBottomContainer = styled.div`
  ${setFullViewportWidthStyles()}
`;

export const StyledHeader = styled(Header)`
  padding-inline: ${alignmentCssVariableValues.headerAlignmentPaddingInline};

  ${theme.breakpoints.only("tablet")} {
    ${setFullViewportWidthStyles}
  }
`;

export const StyledHomeHeader = styled(HomeHeader)`
  ${setFullViewportWidthStyles}
  padding-inline: 12px;

  ${theme.breakpoints.up("tablet")} {
    padding-inline: 24px;
  }
`;

export const StyledPlusHeader = styled(DynamicPlusHeader)`
  ${setFullViewportWidthStyles}
`;
